import { NavLink } from 'react-router-dom';

export default function Aside (props) {
	return (
		<aside className='aside bg-blue-200' style={ props.open ? {opacity: '1', zIndex: '10'} : {}}>
			<div className="aside__inner container flex justify-between items-center mx-auto py-4 px-8 uppercase">
				<nav className="text-left">

					<NavLink end to="/" className="py-2 block" onClick={props.closeMenu}>Все категории</NavLink>
					{props.arr.map((item) => {
						return	<NavLink end to={item.category}
						onClick={props.closeMenu}
						key={item.id}
						className="py-2 block"
						>{item.trans}
						</NavLink>
					}
					)}

				</nav>
			</div>
		</aside>
	)	
}